<button id="back-to-top-btn" class="btn btn-undecorated selection-bg-color shadowed button-to-top" (click)="backToTop()"
        [title]="'component.back_to_top.go_back' | translate" [ngClass]="{'is-in-half-editor': isHalfAndHalf}">
  <fa-icon class="selection-inverse-text-color button-to-top-icon" [icon]="faAngleUp"></fa-icon>
  <span class="sr-only">{{'component.back_to_top.back' | translate}}</span>
</button>
